import React from 'react';
import { withWrapper } from '@shared/react';
import {
    BmoTransactionsTableProvider,
    useBmoTransactionsTable,
    getBmoTransactionsTableColumns,
    getBmoTransactionsTableRows,
    BMO_TRANSACTION_TABLE_TITLE,
    BMO_TRANSACTION_TABLE_INFO_URL,
} from './lib';
import { Table } from '@features/Table';
import { BmoTransactionsTableFilters } from './components';
import './BmoTransactionsTable.scss';

const BmoTransactionsTableContent: React.FC = () => {
    const { bmoTransactions, bmoTransactionsLoading, paginationOptions, onBmoTransactionViewClick } =
        useBmoTransactionsTable();

    return (
        <Table
            columns={getBmoTransactionsTableColumns()}
            data={bmoTransactions}
            dataLoading={bmoTransactionsLoading}
            tableTitle={BMO_TRANSACTION_TABLE_TITLE}
            filters={<BmoTransactionsTableFilters />}
            infoLink={BMO_TRANSACTION_TABLE_INFO_URL}
            paginationOptions={paginationOptions}
            row={getBmoTransactionsTableRows({ onBmoTransactionViewClick })}
        />
    );
};

export const BmoTransactionsTable = withWrapper(BmoTransactionsTableProvider)(BmoTransactionsTableContent);
